import { UserManager, WebStorageStateStore } from "oidc-client-ts";

const cognitoAuthConfig = {
  authority: "https://cognito-idp.us-west-1.amazonaws.com/us-west-1_FK0ejjIEp",
  client_id: "23nbheg3gr394cve9atq310u6r",
  redirect_uri: "https://app.outcomesai.com",
  response_type: "code",
  scope: "email openid phone profile",
  automaticSilentRenew: true,
  loadUserInfo: false,
  filterProtocolClaims: false,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  stateStore: new WebStorageStateStore({ store: window.localStorage }),
};

export const userManager = new UserManager(cognitoAuthConfig);

export const oidcConfig = {
  ...cognitoAuthConfig,
  userManager,
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};

const COGNITO_DOMAIN =
  "https://outcomesai-prod-user-pool-domain.auth.us-west-1.amazoncognito.com";

let _loggingOut = false;

export function isLoggingOut() {
  return _loggingOut;
}

export function cognitoLogout() {
  _loggingOut = true;
  userManager.removeUser();
  window.location.href = `${COGNITO_DOMAIN}/logout?client_id=${cognitoAuthConfig.client_id}&logout_uri=${encodeURIComponent(cognitoAuthConfig.redirect_uri)}`;
}
